import { render, staticRenderFns } from "./ModalPDF.vue?vue&type=template&id=78c80270&"
import script from "./ModalPDF.vue?vue&type=script&lang=js&"
export * from "./ModalPDF.vue?vue&type=script&lang=js&"
import style0 from "./ModalPDF.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports